import { mavlink20 } from './mavlink20Wrapper';

const getFixTypeName = (fixType) => {
    switch (fixType) {
        case mavlink20.GPS_FIX_TYPE_NO_GPS:
            return 'No GPS';
        case mavlink20.GPS_FIX_TYPE_NO_FIX:
            return 'No Fix';
        case mavlink20.GPS_FIX_TYPE_2D_FIX:
            return '2D Fix';
        case mavlink20.GPS_FIX_TYPE_3D_FIX:
            return '3D Fix';
        case mavlink20.GPS_FIX_TYPE_DGPS:
            return 'DGPS';
        case mavlink20.GPS_FIX_TYPE_RTK_FLOAT:
            return 'RTK Float';
        case mavlink20.GPS_FIX_TYPE_RTK_FIXED:
            return 'RTK Fixed';
        case mavlink20.GPS_FIX_TYPE_STATIC:
            return 'Static';
        case mavlink20.GPS_FIX_TYPE_PPP:
            return 'PPP';
        default:
            return 'Unknown';
    }
};

const getMavTypeTargetName = (mavType) => {
    switch (mavType) {
        case mavlink20.MAV_TYPE_FIXED_WING:
        case mavlink20.MAV_TYPE_VTOL_TAILSITTER_DUOROTOR:
        case mavlink20.MAV_TYPE_VTOL_TAILSITTER_QUADROTOR:
        case mavlink20.MAV_TYPE_VTOL_TILTROTOR:
        case mavlink20.MAV_TYPE_VTOL_FIXEDROTOR:
        case mavlink20.MAV_TYPE_VTOL_TAILSITTER:
        case mavlink20.MAV_TYPE_VTOL_TILTWING:
        case mavlink20.MAV_TYPE_VTOL_RESERVED5:
        case mavlink20.MAV_TYPE_VTOL_RESERVED6:
            return "ArduPlane";
        case mavlink20.MAV_TYPE_QUADROTOR:
        case mavlink20.MAV_TYPE_COAXIAL:
        case mavlink20.MAV_TYPE_HELICOPTER:
        case mavlink20.MAV_TYPE_HEXAROTOR:
        case mavlink20.MAV_TYPE_OCTOROTOR:
        case mavlink20.MAV_TYPE_TRICOPTER:
            return "ArduCopter";
        case mavlink20.MAV_TYPE_GROUND_ROVER:
            return "ArduRover";
        case mavlink20.MAV_TYPE_SUBMARINE: 
            return "ArduSub";
        case mavlink20.MAV_TYPE_ANTENNA_TRACKER:
            return "AntennaTracker";
    }
};

const checkParamValue = (paramValue, paramType) => {
    switch (paramType) {
        case mavlink20.MAV_PARAM_TYPE_UINT8:
        case mavlink20.MAV_PARAM_TYPE_INT8:
        case mavlink20.MAV_PARAM_TYPE_UINT16:
        case mavlink20.MAV_PARAM_TYPE_INT16:
        case mavlink20.MAV_PARAM_TYPE_UINT32:
        case mavlink20.MAV_PARAM_TYPE_INT32:
        case mavlink20.MAV_PARAM_TYPE_UINT64:
        case mavlink20.MAV_PARAM_TYPE_INT64:
            if (isNaN(paramValue) || !Number.isInteger(Number(paramValue))) {
                return "Invalid value, need integer";
            }
        case mavlink20.MAV_PARAM_TYPE_REAL32:
        case mavlink20.MAV_PARAM_TYPE_REAL64:
            if (isNaN(paramValue)) {
                return "Invalid value, need float";
            }
        default:
            return null;
    }
};

export { getFixTypeName, getMavTypeTargetName, checkParamValue };